/**
 * axios-instance.js
 * 
 * File for handling axios API requests. Creates an axios instance with the server URL that'll be used
 * within the API files.
 */
import Axios from "axios";
import { getServerHost } from "../util/host";
const { setupCache } = require("axios-cache-interceptor");


const instance = Axios.create({
  baseURL: getServerHost(),
  timeout: 60000,
});
const axios = setupCache(instance);

/**
 * Intercept each request and set additional headers for backend security. The token header ensures that a valid JWT token
 * is being used with each request. The role header ensures that for all endpoints that only require admin access, that an admin
 * is requesting.
 */
axios.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('authToken');
        if (token) {
            config.headers["Authorization"] = 'Bearer ' + token;
        }
        
        return config;
    },
    error => Promise.reject(error)
);


//Export instance
export default axios;

